import { getStamdataFirma, getStamdataPerson } from "../../api/stamdata";
import { getKlientkontoErklaering } from "../../api/klientkontoerklaering";
import { KlientkontoerklaeringMetadata } from "../../interfaces/klientkontoerklaering";
import { fuldtNavn } from "../../lib/stamdataNavn";
import { redirectToLogin } from "../../routerUtil";

export type KlientkontoerklaeringByIdLoaderData = Exclude<
  Awaited<ReturnType<typeof klientkontoerklaeringIdLoader>>,
  Response
>;
export const klientkontoerklaeringIdLoader = async ({ params }) => {
  const { id } = params;
  try {
    const kke = await getKlientkontoErklaering(id);
    const metadata: KlientkontoerklaeringMetadata = {
      senestGemt: kke.sidstAendret,
      startDato: kke.periodeFraDato,
      slutDato: kke.periodeTilDatoMinusEnDag,
      fristDato: kke.frist,
    };
    if (kke.firmaId) {
      const firma = await getStamdataFirma(kke.firmaId);
      metadata.firma = {
        navn: firma.navn,
        cvr: firma.cvr,
      };
    }
    if (kke.personId) {
      const person = await getStamdataPerson(kke.personId);
      // Samme fejl som i tilsynserklæringen: en ren konkatenering gav navnet "null null" for et
      // medlem uden Person-række i portalen (ADV-288). person-nøglen sættes derimod uanset hvad —
      // den betyder "erklæringen er personlig" og styrer bl.a. "Jeg" over for "Advokatselskabet" i
      // erklæringens tekst (HtmlResultSimple). Det er kun navnet, vi mangler, og her har vi ikke en
      // standardværdi at falde tilbage på som tilsynserklæringen, så den står eksplicit.
      metadata.person = { navn: fuldtNavn(person) || "ukendt person" };
    }
    return { kke, metadata };
  } catch (error) {
    if (error === "Request failed with status code 404") {
      return {
        error: 404,
      };
    }
    return redirectToLogin(true);
  }
};
